import RoomSearchParameters from 'src/app/shared/models/roomSearchParams.model';
import { HttpParams } from '@angular/common/http';
import CustomURIEncoder from 'src/app/helpers/utils/CustomURIEncoder';
import { getFormattedTimezoneOffset } from 'src/app/helpers/utils/date.utils';
import { SpaceType } from 'src/app/shared/constants/spaceTypes.constant';
import { DiscountType } from 'src/app/services/time-slot-discounts/time-slot-discounts.service';

// TODO create a unified method

export const createDefaultSearchParams = (parameters: RoomSearchParameters): HttpParams => {
  return new HttpParams({ encoder: new CustomURIEncoder() })
    .set('spaceType', parameters.spaceType === 'meetingRoom' ? 'MeetingRoomOrTrainingRoom' : parameters.spaceType)
    .set('TimezoneOffset', getFormattedTimezoneOffset())
    .set('location', parameters.location);
}

export const createRoomSearchParams = (
  parameters: Partial<RoomSearchParameters>,
  centreCount: number = 60
): HttpParams => {
  let httpParams = new HttpParams({ encoder: new CustomURIEncoder() })
    .set(
      'spaceType',
      parameters.spaceType === SpaceType.MEETING_ROOM ? 'MeetingRoomOrTrainingRoom' : parameters.spaceType
    )
    .set('date', parameters.date ?? '')
    .set('timeFrom', parameters.timeFrom ?? '')
    .set('timeUntil', parameters.timeUntil ?? '')
    .set('timeSlotType', parameters.timeSlotType || DiscountType.SpecificTime)
    .set('numberOfPeople', parameters.numberOfPeople?.toString() ?? 0)
    .set('TimezoneOffset', getFormattedTimezoneOffset())
    .set('location', parameters.location)
    .set('centreCount', centreCount);

  if (parameters.coordinatesLongitude && parameters.coordinatesLatitude) {
    httpParams = httpParams
      .set('coordinates.longitude', parameters.coordinatesLongitude)
      .set('coordinates.latitude', parameters.coordinatesLatitude);
  }
  if (parameters.lastCentreNumber) {
    httpParams = httpParams.set('lastCentreNumber', parameters.lastCentreNumber);
  }
  return httpParams;
}

export const createUnavailableRoomSearchParams = (parameters: Partial<RoomSearchParameters>): HttpParams => {
  let httpParams = new HttpParams({ encoder: new CustomURIEncoder() })
    .set('spaceType', parameters.spaceType === 'meetingRoom' ? 'MeetingRoomOrTrainingRoom' : parameters.spaceType)
    .set('date', parameters.date ?? '')
    .set('timeFrom', parameters.timeFrom ?? '')
    .set('timeUntil', parameters.timeUntil ?? '')
    .set('numberOfPeople', parameters.numberOfPeople?.toString() ?? 0)
    .set('TimezoneOffset', getFormattedTimezoneOffset())
    .set('location', parameters.location)
    .set('centreCount', 100);

  if (parameters.coordinatesLongitude && parameters.coordinatesLatitude) {
    httpParams = httpParams
      .set('coordinates.longitude', parameters.coordinatesLongitude)
      .set('coordinates.latitude', parameters.coordinatesLatitude);
  }

  if (parameters.lastCentreNumber) {
    httpParams = httpParams.set('lastCentreNumber', parameters.lastCentreNumber);
  }
  return httpParams;
}
